import React from 'react'
import '../../css/aboutUs/infrastructure.css'

export default function Infrastructure() {
  return (
    <div className="infrastructure" style={{overflow:"hidden"}}>
        <h1 data-aos="zoom-in">INFRASTRUCTURE</h1>
        <img src="assets/about/infrastructure.png" alt="" data-aos="fade-right" />
        <p data-aos="fade-left">Our Factory has a build up area of 25000 Sq.ft equipped with all We sophisticated machinery and skilled man power.</p>
    </div>
  )
}
